export const COLOR_ERROR = 'error';
export const COLOR_WARNING = 'warning';
export const COLOR_SUCCESS = 'success';
export const COLOR_INFO = 'info';
export const COLOR_PRIMARY = 'primary';
export const COLOR_SECONDARY = 'secondary';
